export default __webpack_public_path__ + "static/media/h7.e2a89a66.jpg";